import React from 'react';
import Modal from 'react-modal'; // Use the library you already have
import styles from './ConfirmationModal.module.css';

// react-modal uses custom style objects, but we can also use classNames
// to leverage our existing CSS module for a consistent look.
const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    // We override most of these with our CSS module class below
    position: 'relative',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    border: 'none',
    background: 'transparent',
    overflow: 'visible',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '0',
    outline: 'none',
    padding: '0',
  },
};

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  children,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isConfirming = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose} // This is how react-modal handles closing (e.g., on ESC key or overlay click)
      style={customStyles}
      contentLabel={title} // Important for accessibility
    >
      {/* We apply our own styled container class here */}
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h4>{title}</h4>
          <button onClick={onClose} className={styles.closeButton}>×</button>
        </div>
        <div className={styles.modalBody}>
          {children}
        </div>
        <div className={styles.modalFooter}>
          <button onClick={onClose} className={styles.cancelButton} disabled={isConfirming}>
            {cancelText}
          </button>
          <button onClick={onConfirm} className={styles.confirmButton} disabled={isConfirming}>
            {isConfirming ? <div className={styles.spinner}></div> : confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;